import { useEffect, useState } from 'react';

const STORAGE_KEY = 'mcc-study-progress-v1';
const EVENT_NAME = 'mcc-progress-changed';

export function readProgress() {
  try {
    const saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}');
    return saved && typeof saved === 'object' && !Array.isArray(saved) ? saved : {};
  } catch {
    return {};
  }
}

export function markCompleted(key) {
  if (!key) return;
  const data = { ...readProgress(), [key]: new Date().toISOString() };
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    window.dispatchEvent(new Event(EVENT_NAME));
  } catch {
    // Exercises remain playable even if browser storage is disabled.
  }
}

export function useProgress() {
  const [progress, setProgress] = useState(readProgress);
  useEffect(() => {
    const refresh = () => setProgress(readProgress());
    window.addEventListener(EVENT_NAME, refresh);
    window.addEventListener('storage', refresh);
    return () => {
      window.removeEventListener(EVENT_NAME, refresh);
      window.removeEventListener('storage', refresh);
    };
  }, []);
  return progress;
}
